function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

export default function() {
  return this.each(lower);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-transition/~/d3-selection/src/selection/lower.js
// module id = u7Gm
// module chunks = 0